import React from "react";
import { Minus, Plus } from "lucide-react";
import { cn } from "@/lib/format";

type Props = {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  label?: string;
  className?: string;
};

export const Stepper = React.forwardRef<HTMLDivElement, Props>(
  ({ value, onChange, min = 1, max = 99, label, className }, ref) => {
    const canDecrement = value > min;
    const canIncrement = value < max;

    return (
      <div ref={ref} className={cn("flex items-center gap-3", className)}>
        {label && (
          <label className="text-sm font-medium text-muted">{label}</label>
        )}
        <div className="flex items-center gap-2 border border-line rounded-lg p-1">
          <button
            type="button"
            onClick={() => onChange(Math.max(value - 1, min))}
            disabled={!canDecrement}
            aria-label="Decrease"
            className="inline-flex h-8 w-8 items-center justify-center rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:bg-bg"
          >
            <Minus size={16} className="text-muted" />
          </button>
          <span className="min-w-8 text-center font-semibold text-headings">
            {value}
          </span>
          <button
            type="button"
            onClick={() => onChange(Math.min(value + 1, max))}
            disabled={!canIncrement}
            aria-label="Increase"
            className="inline-flex h-8 w-8 items-center justify-center rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:bg-bg"
          >
            <Plus size={16} className="text-muted" />
          </button>
        </div>
      </div>
    );
  }
);

Stepper.displayName = "Stepper";
